import MyTable from '../../../../components/MyTable';
import FilterPopup from '../../../../components/FilterPopup';
import { formatPhone } from '../../../../utlis';

const SalesContactsTable = ({
  data,
  isLoading,
  onEditContact,
  pageSize,
  onPageSizeChange,
  isFilterPopupOpen,
  onFilterClick,
  onCloseFilterPopup,
  onApplyFilters,
  getSearchResults,
}) => {
  const columns = [
    {
      name: 'contact_id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'last_name',
      label: 'last_name',
      options: {
        display: false,
      },
    },
    {
      name: 'first_name',
      label: 'Contact Name',
      options: {
        customBodyRender: (value, tableMeta) => {
          const firstName = tableMeta.rowData[tableMeta.columnIndex];
          const lastName = tableMeta.rowData[tableMeta.columnIndex - 1];
          const fullName = lastName ? `${firstName} ${lastName}` : firstName;
          return (
            <h3
              onClick={() => onEditContact(tableMeta.rowData[0])}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {fullName}
            </h3>
          );
        },
      },
    },
    {
      name: 'contact_type',
      label: 'Contact Type',
    },
    {
      name: 'phone',
      label: 'Phone Number',
      options: {
        customBodyRender: (value) => {
          if (value) {
            const mobile = value.mobile;
            return formatPhone(mobile);
          }
          return '';
        },
      },
    },
    {
      name: 'email',
      label: 'Email',
    },
    {
      name: 'address',
      label: 'Address',
      options: {
        customBodyRender: (value) => {
          if (value) {
            const { address_line1, address_line2, city, state, zip } = value;
            const lines = [];

            // Add Address Line 1 if exists
            if (address_line1) lines.push(address_line1);

            // Add Address Line 2 if exists
            if (address_line2) lines.push(address_line2);

            // Build City, State Zip line
            const cityStateZip = [city, state].filter(Boolean).join(', ');
            const locationLine = zip ? `${cityStateZip} ${zip}`.trim() : cityStateZip;
            if (locationLine) lines.push(locationLine);

            return (
              <div className="flex flex-col">
                {lines.map((line, index) => (
                  <span key={index}>{line}</span>
                ))}
              </div>
            );
          }
          return '';
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRender: (value) => {
          // Format status for display (capitalize first letter, lowercase rest)
          const formatStatus = (status) => {
            if (!status) return '';
            return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
          };

          // Determine styling based on status
          const getStatusStyle = (status) => {
            const statusUpper = (status || '').toUpperCase();
            if (statusUpper === 'ACTIVE') {
              return 'text-secondary-500';
            } else if (statusUpper === 'FRAUD') {
              return 'text-orange-500';
            } else {
              return 'text-danger-500';
            }
          };

          return (
            <p className={`py-2 rounded-full w-32 text-left ${getStatusStyle(value)}`}>
              {formatStatus(value)}
            </p>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    filter: true,
    search: false, // We have our own search in header
    download: true,
    print: true,
    viewColumns: true,
    textLabels: {
      body: {
        noMatch: !isLoading && (!data || data.length === 0) ? 'Sorry, no matching found' : '',
      },
    },
  };

  const filterCategories = [
    'ID',
    'last_name',
    'Contact Name',
    'Contact Type',
    'Phone Number',
    'Email',
    'Address',
    'Status',
  ];

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={isLoading ? [] : data}
        columns={columns}
        options={options}
        onFilterClick={onFilterClick}
      />
      {isFilterPopupOpen && (
        <FilterPopup
          onClose={onCloseFilterPopup}
          onApply={onApplyFilters}
          tableData={data}
          categories={filterCategories}
          getSearchResults={getSearchResults}
        />
      )}
    </div>
  );
};

export default SalesContactsTable;
